import React from 'react';
import * as DatesUtils from '../../utils/dates';
import { Languages } from '../../config';
import ActionsBlock from './components/datatable/ActionsBlock';

const CONFIGURATION = {};

export default CONFIGURATION;

export const TableColumns = [
  {
    label: 'Country',
    id: 'country_code',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        {data[rowIndex].country_code} - {data[rowIndex].country_name}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Rate Type',
    id: 'vat_rate_type',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}</React.Fragment>,
    inData: true,
  },
  {
    label: 'VAT Rate',
    id: 'vat_rate',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{cellValue}%</React.Fragment>,
    inData: true,
  },
  {
    label: 'Valid From',
    id: 'valid_from',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => <React.Fragment>{DatesUtils.formatDate(cellValue)}</React.Fragment>,
    inData: true,
  },
  {
    label: 'Valid To',
    id: 'valid_to',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        {cellValue ? DatesUtils.formatDate(cellValue) : '-'}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        vat_rate_id={data[rowIndex].vat_rate_id}
        vat_rate_type_id={data[rowIndex].vat_rate_type_id}
        country_code={data[rowIndex].country_code}
        country_name={data[rowIndex].country_name}
        vat_rate={data[rowIndex].vat_rate}
        valid_from={data[rowIndex].valid_from}
        valid_to={data[rowIndex].valid_to}
      />
    ),
    inData: false,
  },
];

export const Translations = {
  page_title: {
    [Languages.Greek]: 'VAT Rates',
    [Languages.English]: 'VAT Rates',
  },
  table_title: {
    [Languages.Greek]: 'VAT Rates',
    [Languages.English]: 'VAT Rates',
  },
  go_to_dashboard: {
    [Languages.Greek]: 'Go to dashboard',
    [Languages.English]: 'Go to dashboard',
  },
  search: {
    [Languages.Greek]: 'Search',
    [Languages.English]: 'Search',
  },
  clear: {
    [Languages.Greek]: 'Clear',
    [Languages.English]: 'Clear',
  },
  country_code_filter: {
    [Languages.Greek]: 'Country Code',
    [Languages.English]: 'Country Code',
  },
  vat_rate_type_filter: {
    [Languages.Greek]: 'VAT Rate Type',
    [Languages.English]: 'VAT Rate Type',
  },
  valid_from_filter: {
    [Languages.Greek]: 'Valid From',
    [Languages.English]: 'Valid From',
  },
  valid_to_filter: {
    [Languages.Greek]: 'Valid To',
    [Languages.English]: 'Valid To',
  },
};
